import { Stack } from "@mantine/core"
import classes from "./SideNavBar.module.css"
import { BASE_TEST_ID } from "@/components/generic/SideNavBar/constants"
import { NavbarOptionSkeletonButton } from "@/components/generic/SideNavBar/components/NavbarOptionButton/NavbarOptionSkeletonButton"

export function SkeletonSideNavBar() {
  return (
    <Stack component="nav" pb={"md"} className={classes.nav} justify="space-between" data-testid={`${BASE_TEST_ID}container`}>
      <Stack justify="center" gap={8} align="center">
        {/* Welcome: /welcome */}
        <NavbarOptionSkeletonButton />

        {/* Messenger: / & /messenger */}
        <NavbarOptionSkeletonButton />

        {/* Power Dialer: /power-dialer & /scheduled/calls */}
        <NavbarOptionSkeletonButton />

        {/* Contacts: /contact/* */}
        <NavbarOptionSkeletonButton />

        {/* Content: /templates/email/library & /templates/sms/library & /call/scripts */}
        <NavbarOptionSkeletonButton />

        {/* Sequences: /sequences/library */}
        <NavbarOptionSkeletonButton />

        {/* Stats: /stats */}
        <NavbarOptionSkeletonButton />

        {/* Live Monitor: /live-monitor */}
        <NavbarOptionSkeletonButton />
      </Stack>

      <Stack justify="center" gap={8} align="center">
        <NavbarOptionSkeletonButton />
        <NavbarOptionSkeletonButton />
      </Stack>
    </Stack>
  )
}
